import type { SVGProps } from 'react';
import { forwardRef, Ref } from 'react';

const SvgVerduurzaming = (
  props: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 40 40"
    role="img"
    aria-hidden={true}
    ref={ref}
    {...props}
  >
    <path
      fill="#B3E9B1"
      fillRule="evenodd"
      d="m6.29 18.88 9-6.55 9.01 6.55v14.74H6.29z"
      clipRule="evenodd"
    />
    <path
      fill="#60D15D"
      d="M15.29 23.79H9.56v9.83h5.73z"
    />
    <path
      fill="#60D15D"
      fillRule="evenodd"
      d="m36.77 24.57-2.69-2.69c.4-2.88 1.78-8.38-1.77-11.88C27.67 5.32 17 6.52 17 6.52s-1.2 10.64 3.44 15.28C24 25.34 29.53 24 32.4 23.57l2.69 2.69z"
      clipRule="evenodd"
    />
    <path
      fill="#C3E8B2"
      fillRule="evenodd"
      d="m21.424 10.196 10.43 10.43-.707.707-10.43-10.43z"
      clipRule="evenodd"
    />
    <path
      fill="#C3E8B2"
      fillRule="evenodd"
      d="M29.59 12.39v6.68H22.9v-1h5.69v-5.68z"
      clipRule="evenodd"
    />
    <path
      fill="#C3E8B2"
      fillRule="evenodd"
      d="M26.03 11v4.51h-4.51v-1h3.51V11z"
      clipRule="evenodd"
    />
    <path
      fill="#00215B"
      fillRule="evenodd"
      d="M25.545 26.926c-2.252-.05-4.664-.612-6.559-2.513l.708-.706c1.645 1.65 3.763 2.172 5.873 2.22 1.662.037 3.261-.22 4.587-.431q.56-.092 1.047-.161l.244-.034 2.906 2.863-.702.712-2.553-2.516q-.342.053-.734.116c-1.33.213-3.054.49-4.817.45M13.324 17.264l-9.01 6.55-.588-.808 9.01-6.55z"
      clipRule="evenodd"
    />
  </svg>
);

/* eslint-disable import/no-default-export */
const ForwardRef = forwardRef(SvgVerduurzaming);

export default ForwardRef;
